import * as z from "zod";

export const assignWorkOrderTote = {
  name: "assignWorkOrderTote" as const,
  input: z.object({ workOrderId: z.string(), barcode: z.string() }),
  output: z.object({
    success: z.boolean(),
    toteStorageLocationId: z.string(),
    toteStorageLocationName: z.string(),
  }),
};
